import firebase from "firebase/app";
import { firestore, auth } from "./firebase";
import { uploadClientLogo } from "./storage";

// Sign In
export const createNewProject = (account, name, client, success, error) => {
  firestore
    .collection(`accounts/${account}/projects`)
    .add({
      name: name,
      client: client,
      creator: auth.currentUser.uid,
      status: 0,
      timestamp: firebase.firestore.FieldValue.serverTimestamp()
    })
    .then(success)
    .catch(error);
};

export const getProject = (account, id, success, error) => {
  firestore
    .collection(`accounts/${account}/projects`)
    .doc(id)
    .get()
    .then(success)
    .catch(error);
};

export const getClient = (account, clientId, success, error) => {
  firestore
    .collection(`accounts/${account}/clients`)
    .doc(clientId)
    .get()
    .then(success)
    .catch(error);
};

export const getClientUpdates = (account, onNewData) => {
  return firestore
    .collection(`accounts/${account}/clients`)
    .onSnapshot(docs => onNewData(docs));
};

export const getSingleClientUpdates = (account, clientId, onUpdate) => {
  return firestore
    .collection(`accounts/${account}/clients`)
    .doc(clientId)
    .onSnapshot(doc => onUpdate(doc));
};

export const getProjectUpdates = (account, id, onNewData) => {
  return firestore
    .collection(`accounts/${account}/projects/${id}/documents`)
    .onSnapshot(docs => onNewData(docs));
};

export const listProjects = (account, clientId, success, error) => {
  firestore
    .collection(`accounts/${account}/projects`)
    .where(`client`, `==`, clientId)
    .orderBy(`timestamp`, "desc")
    .get()
    .then(success)
    .catch(error);
};

export const listActivities = (account, filter, success, error) => {
  var query = firestore
    .collection(`accounts/${account}/activities`)
    .orderBy("timestamp", "desc");

  if (filter !== null && filter !== undefined) {
    query = query.where("user", "==", filter);
  }

  query
    .get()
    .then(success)
    .catch(error);
};

export const saveDocument = (
  account,
  projectId,
  fileName,
  fileUrl,
  storageRef,
  fileType,
  success,
  error
) => {
  firestore
    .collection(`accounts/${account}/projects/${projectId}/documents`)
    .add({
      name: fileName,
      url: fileUrl,
      storagePath: storageRef,
      type: fileType
    })
    .then(success)
    .catch(error);
};

export const deleteDocument = (account, projectId, docId, finished, err) => {
  firestore
    .collection(`accounts/${account}/projects/${projectId}/documents`)
    .doc(docId)
    .delete()
    .then(finished)
    .catch(error => err(error));
};

// Create New Client
export const createNewClient = (account, client, logoFile, success, error) => {
  //Add Data
  client.created = firebase.firestore.FieldValue.serverTimestamp();

  //Save to Database
  firestore
    .collection(`accounts/${account}/clients`)
    .add(client)
    .then(doc => {
      uploadClientLogo(account, logoFile, doc.id, path => {
        success();
      });
    })
    .catch(error);
};

export const getNotificationUpdates = (account, onlyNew, onNewData) => {
  const ref = firestore.collection(`accounts/${account}/notifications`);

  let query = null;
  if (onlyNew === true) {
    query = ref.where("read", "==", false).orderBy("created");
  } else {
    query = ref.orderBy("created", "desc");
  }

  return query.onSnapshot(docs => onNewData(docs));
};

export const setNotificationReadState = (account, id, read) => {
  const ref = firestore.collection(`accounts/${account}/notifications`).doc(id);
  ref.update({ read: read });
};

export const commitProjectToClient = (
  account,
  clientId,
  projectId,
  success,
  error
) => {
  const clientRef = firestore
    .collection(`accounts/${account}/clients`)
    .doc(clientId);

  const approvalRequest = {
    client: clientRef,
    project: projectId,
    creator: auth.currentUser.uid,
    created: firebase.firestore.FieldValue.serverTimestamp()
  };

  //Change Status
  firestore
    .collection(`accounts/${account}/projects`)
    .doc(projectId)
    .update({ status: 4 })
    .then(doc => {})
    .catch(err => {});

  //Save to Database
  firestore
    .collection(`accounts/${account}/approvals`)
    .add(approvalRequest)
    .then(doc => success())
    .catch(err => error(err));
};

export const getMyAccount = (userId, success, error) => {
  //Get User Profile
  firestore
    .collection("users")
    .doc(userId)
    .get()
    .then(doc => {
      //Get Membership
      const membership = doc.data().account_membership;
      if (membership) {
        //Get Organisation you are a part of
        firestore
          .collection("accounts")
          .doc(membership)
          .get()
          .then(doc => {
            //Does the Organisation exist? (It only exists if I am actually a member)
            if (doc.exists)
              success(membership, doc.data().name, doc.data().admin);
            else error();
          })
          .catch(error);
      } else error();
    })
    .catch(error);
};

export const listUsers = (account, success, error) => {
  firestore
    .collection(`users`)
    .where(`account_membership`, `==`, account)
    .orderBy(`accession`)
    .get()
    .then(success)
    .catch(error);
};

export const getMyProfile = (authId, success, error) => {
  firestore
    .collection("users")
    .doc(authId)
    .get()
    .then(success)
    .catch(error);
};



// WEBPACK FOOTER //
// ./src/firebase/firestore.js